import React, { useState } from 'react';

export const Navigation = (props) => {


  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          
           
          <a className='navbar-brand page-scroll' href='/'>
            <img style={{ height: 50, overflow: 'hidden', }} align="left" src="img/logorocarenew.png" alt='best ro-repair service' />
          </a>{' '}
        </div>

        <div id='bs-example-navbar-collapse-1'>
          <ul className='nav navbar-nav navbar-right'>
            {/* <li>
              <a className="btn" href="mailto: carerorepair@gmail.com" ><i className="fa fa-envelope" style={{fontSize :"12px"}}> </i> carerorepair@gmail.com</a>
            </li> */}
            
            <li>

              <a className="btn" href="tel:9310176089" ><i className="fa fa-phone" style={{fontSize :"16px", cursor:"pointer"}}> +91-9310176089</i></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
